import {
  LineChart as RCLineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
} from 'recharts';
import { NameType, ValueType } from 'recharts/types/component/DefaultTooltipContent';
import { TooltipProps } from 'recharts/types/component/Tooltip';

interface CustomLineChartProps {
  data: any[];
  dataKey: string;
}

const CustomTooltip: (props: TooltipProps<ValueType, NameType>) => React.ReactNode = ({
  active,
  payload,
  label,
}) => {
  if (active && payload && payload.length) {
    const percentage = payload[0].value as number;
    const date = new Date(label);
    return (
      <div className="hidden sm:flex rounded-md border border-[rgb(34,50,83)] bg-gray-900 px-3 py-1 flex-col gap-1">
        <p className="text-muted-foreground text-lg">
          {date.toLocaleDateString('en-US', {
            month: 'short',
            day: 'numeric',
            year: 'numeric',
          })}
        </p>
        <p className="text-white text-right">{Number(percentage)}</p>
      </div>
    );
  }

  return null;
};

export function LineChart({ data, dataKey }: CustomLineChartProps) {
  return (
    <ResponsiveContainer width="100%" height={200}>
      <RCLineChart data={data} margin={{ top: 5, right: 5, left: -20, bottom: 0 }}>
        <XAxis
          dataKey="date"
          tickFormatter={str => {
            const date = new Date(str);
            return `${date.getMonth() + 1}/${date.getDate()}`;
          }}
          stroke="#64748b"
          fontSize={12}
          axisLine={{ stroke: '#374151' }}
          tickLine={false}
          dy={10}
        />
        <YAxis
          stroke="#64748b"
          fontSize={12}
          axisLine={{ stroke: '#374151' }}
          tickLine={false}
          dx={-10}
        />
        <Line type="monotone" dataKey={dataKey} stroke="#3b82f6" strokeWidth={2} dot={false} />

        <Tooltip content={<CustomTooltip />} />
      </RCLineChart>
    </ResponsiveContainer>
  );
}
